const DEFAULT_EXPIRY_TIME = 24 * 3600 * 1000;
export const REDIRECT_TO_COOKIE_KEY = 'redirectTo';
export const TOKEN_COOKIE_KEY = 'token';

export function setCookie(
  key,
  value,
  highLevelDomain = false,
  expiresIn = DEFAULT_EXPIRY_TIME
) {
  const expiryTime = new Date();
  expiryTime.setTime(expiryTime.getTime() + expiresIn);
  const domainPart = highLevelDomain ? getDomainPart() : '';
  const expiresPart = `; expires=${expiryTime.toUTCString()}`;
  document.cookie = `${key}=${value}${expiresPart}${domainPart};path=/`;
}

export function getCookie(key) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + key + '=');
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
}

export function deleteCookie(key, highLevelDomain = false) {
  const domainPart = highLevelDomain ? getDomainPart() : '';
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT${domainPart};path=/`;
}

function getDomainPart() {
  const hostname = window.location.hostname;
  const highLevelDomainIndex = hostname.indexOf('.');
  const domain =
    highLevelDomainIndex > -1
      ? hostname.substr(highLevelDomainIndex)
      : hostname;
  return `;domain=${domain}`;
}
